module.exports = __webpack_public_path__ + "img/m&k_logo.baa69b70.png";